import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import z from 'zod'

export const codeGenerationSchema = z.object({
  code_instructions: z.string().min(1, 'Code instructions are required'),
})

export type CodeGenerationFormValues = z.infer<typeof codeGenerationSchema>

export const codeGenerationFormFields: GenericFieldConfig<CodeGenerationFormValues> = [
  {
    name: 'code_instructions',
    componentType: 'textarea',
    zodValidation: codeGenerationSchema.shape.code_instructions,
    inputProps: {
      placeholder: 'Please provide clear and detailed instructions to generate code.',
      className: 'min-h-[200px]',
      'data-testid': 'textarea-code-instructions',
    },
  },
]
